/*
 * N49 Framework
 * 2020-2021
 * Author: Wasim al Hafez
 */


(function ($) {

    let N49 = {

        debug: false,
        ajaxURL: "//" + location.host + "/wp-admin/admin-ajax.php",

        init: function (debug = false) {

            this.debug = debug;
            this.layout__header();
            this.block__hero_slider();
            this.mobile__menu();
            this.accordion();
            this.gallery();
            this.archive_table_ajax();
            this.events_form();
            this.team_filter();
            this.yt_block();
        },

        layout__header: function () {

            function MenuPointer(event = 'move', _element = null, animate = true) {

                if (event === 'kill') {
                    $('.js--menu-pointer').stop(true).animate({
                        'width': '0',
                    }, 'fast');
                    return;
                }

                if (event === 'set') {
                    $('.js--menu-pointer').stop(true).animate({
                        'width': '30px',
                    }, 'fast');
                    return;
                }

                if (event === 'move' && _element != null) {

                    let relativeY = (_element.offset().top - $(".header--content").offset().top) + 70;
                    let relativeX = _element.offset().left - $(".header--content").offset().left;
                    if (animate) {
                        $('.js--menu-pointer').stop(true).css({
                            'background-color': '#ffffff',
                            'width': '30px',
                            'height': '3px'
                        }).animate({top: relativeY, left: relativeX}, 'fast');
                    } else {
                        $('.js--menu-pointer').css({
                            'background-color': '#ffffff',
                            'width': '30px',
                            'height': '3px',
                            top: relativeY,
                            left: relativeX,
                        });
                    }

                    return;
                }

            }


            //LogoSwitcher();

            MenuPointer('move', $('.js--megamenu>li:first'), false);


            // Check every mousemove if the mouse on the Menu elements and Hide it if it leaves
            $(window).on('mousemove', function () {

                if (
                    $('.megamenu-container:hover').length === 0
                    && $('.header--menu:hover').length === 0

                ) {
                    $('.header--menu').find('.megamenu-container').removeClass('is-active');

                }

            });

            // Hide MegaMenu On Click on outside
            document.body.onclick = function () {
                $('.header--menu').find('.megamenu-container').removeClass('is-active');

            }


            $('.js--megamenu>li>a').hover(function () {

                let _parent = $(this).parent();
                let _has_children = _parent.hasClass('menu-item-has-children');

                let _megamenu = _parent.find('.megamenu-container');
                let _other_megamenu = _parent.siblings().find('.megamenu-container');


                MenuPointer('move', _parent);

                if (_has_children) {

                    _other_megamenu.removeClass('is-active');
                    _megamenu.addClass('is-active');

                } else {
                    _other_megamenu.removeClass('is-active');
                }
            });


            $('.js--megamenu .submenu-container>.sub-menu>li>a').hover(function () {
                let _parent = $(this).parent();
                let _has_children = _parent.find('.sub-menu').length > 0;

                let _menu = _parent.find('.sub-menu');
                let _other_menu = _parent.siblings().find('.sub-menu');

                if (_has_children) {
                    _other_menu.removeClass('is-active');
                    _menu.addClass('is-active');
                } else {
                    _other_menu.removeClass('is-active');
                }
            });


            $('.js--search-open').on('click', function () {
                var el = $('.header--search-floating');

                el.fadeIn(200);

                el.addClass('is-active');
                //$('.js--megamenu').addClass('hide-nav');
                $('.header--search-floating input').focus();
                //MenuPointer('kill');
            });

            $('.js--search-close').on('click', function () {
                var el = $('.header--search-floating');

                el.fadeOut(300);

                el.removeClass('is-active');
                //$('.js--megamenu').removeClass('hide-nav');
                //MenuPointer('set');
            });


            $(".header--search-floating input").on("keydown", function (event) {
                if (event.which == 13)
                    location.href = window.location.origin + '/?s=' + $('.header--search-floating input').val();
            });

        },


        block__hero_slider: function () {

            $('.js--home-hero').not('.slick-initialized').slick({
                dots: true,
                infinite: true,
                slidesToShow: 1,
                adaptiveHeight: false,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 5000,
            });

        },

        mobile__menu: function () {

            var slideout = new Slideout({
                'panel': document.getElementById('mobile-panel'),
                'menu': document.getElementById('mobile-menu'),
                'padding': 320,
                'tolerance': 70,
                'side': 'right',
                'touch': false
            });


            $('.mobile-trigger').on('click', function () {
                slideout.toggle();

                if (slideout.isOpen()) {
                    $(this).children("i").removeClass("icon-ui-menu");
                    $(this).children("i").addClass("icon-ui-close");
                } else {
                    $(this).children("i").removeClass("icon-ui-close");
                    $(this).children("i").addClass("icon-ui-menu");
                }
            });

            $('.mobile-close-icon').on('click', function () {
                slideout.toggle();
                $(this).children("i").removeClass("icon-ui-close");
                $(this).children("i").addClass("icon-ui-menu");

                $(".hamburger-tablet").children("i").removeClass("icon-ui-close");
                $(".hamburger-tablet").children("i").addClass("icon-ui-menu");
            });

            var myMenu = $(".menu");

            myMenu.find(".menu-item-has-children").each(function (index, item) {
                let link = $(item).find(">a").attr("href");

                $(item).find(">.sub-menu").prepend("<li><a href='" + link + "'>Übersicht</a></li>");
            });

            myMenu.find("li.menu-item-has-children>a").each(function (index, item) {
                menudrop = $(this).parent();
                $(this).append('<i class="icon icon-arrow-solid-right"></i>');
            });


            myMenu.find("li.menu-item-has-children>a").on("click", function (evt) {
                evt.preventDefault();
                evt.stopPropagation();


                let menuItem = $(this).parent();
                let icon = $(this).children("i");


                if (menuItem.hasClass("is-active")) {
                    menuItem.removeClass("is-active");
                    icon.css("transform", "");
                } else {
                    menuItem.addClass("is-active").siblings().removeClass("is-active");
                    icon.css("transform", "rotate(90deg)");
                }

            });


        },

        gallery: function () {
            $('.js--company-gallery').not('.slick-initialized').slick({
                // autoplay: true,
                // autoplaySpeed: 2000,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                adaptiveHeight: false,
                arrows: true,
                dots: true,
                infinite: true,
            });
        },

        accordion: function () {

            let accordion = $('.js--accordion');

            accordion.find(".accordion-section-title").on("click", function (evt) {
                evt.preventDefault();
                evt.stopPropagation();

                let accordionItem = $(this).parent();

                if (accordionItem.hasClass("is-active")) {
                    accordionItem.removeClass("is-active");
                } else {
                    accordionItem.addClass("is-active").siblings().removeClass("is-active");
                }

            });
        },

        slickSliderResponsive: function () {

            $('.slick-initialized').each(function (index, s) {
                let classes = $(s).attr("class").split(/\s+/);

                $(classes).each(function (index, cls) {
                    if (cls.indexOf("js--") >= 0) {

                        let slickClass = '.' + classes[index];
                        console.log(slickClass);
                        $(slickClass).on('resize', function (event, slick) {
                            console.log('Slick Updated');
                        });
                        $(window).resize(function () {
                            $(slickClass).slick('resize');
                        });

                        $(window).on('orientationchange', function () {
                            $(slickClass).slick('reinit');
                        });
                    }
                });
            });
        },

        archive_table_ajax: function () {


            let _container = '.js--archive-ajax';


            $(_container).each(function () {

                let _archive = $(this);
                let _ID = '#' + _archive.attr('id');

                let _list_container = _archive.find('.list-container');
                let _list_pagination = _archive.find('.list-pagination');
                let _filter_container = _archive.find('#js--filter-form');
                let _search = _archive.find('.js--search-input');


                let per_page = _archive.data('ppage');
                let category = _archive.data('category');
                let action = _archive.data('action');

                let _filter = SimpleFilter(_filter_container);


                let page = 1;

                let opt = {
                    ajax_url: N49.ajaxURL,
                    action: action,
                    per_page: per_page,
                    category: category,
                    page: page,
                    filter: _filter,

                    list_container: _ID + ' .list-container',
                    list_pagination: _ID + ' .list-pagination',
                };

                // OnLoad detect hash.
                if (window.location.search) {
                    let hash = window.location.search.substring(1);
                    let paramsString = decodeURIComponent(hash);
                    let _Query = Object.fromEntries(new URLSearchParams(paramsString));

                    if (typeof (_Query.search) != "undefined" && _Query.search !== null) {
                        _search.val(_Query.search);
                    }

                    if (typeof (_Query.filter) != "undefined" && _Query.filter !== null) {
                        _archive.find('.js--filter-trigger').addClass('is-active');
                    }

                    opt = $.extend(opt, _Query);
                    call_posts(opt, true);
                }


                // Search system
                let do__search = function () {
                    let term = _search.val();
                    if (term.length >= 3) {
                        opt.search = term;
                        opt.page = 1;
                        call_posts(opt, true);
                    }

                    if (term.length === 0) {
                        opt.search = "";
                        opt.page = 1;
                        call_posts(opt, true);
                    }
                }

                _search.on('keyup', delay(function (e) {
                    do__search();
                }, 500));

                _archive.find('.search--form button').click(function () {
                    do__search();
                });

                // Pagination system
                _list_pagination.on('click', 'li:not(.is-active) > button[data-page]', function () {
                    $(this).parent().addClass('is-active').siblings().removeClass('is-active');
                    opt.page = $(this).data('page');
                    call_posts(opt);
                });

                // Reset On not Found
                _archive.on('click', '.js--ajax-reset', function () {

                    _filter_container.find('input[type=checkbox]').prop("checked", false);
                    opt.search = "";
                    opt.page = 1;
                    opt.filter = null;

                    _search.val('');

                    call_posts(opt, true);
                });

                // Submit the filter
                _archive.on('click', ".filter-submit button[name=submit]", function () {

                    opt.filter = SimpleFilter(_filter_container);
                    opt.page = 1;

                    if (_archive.find('.js--filter-inner').hasClass('is-active')) {
                        _archive.find('.js--filter-inner').removeClass('is-active');
                    }

                    call_posts(opt, true);

                });

                // Reset the filter
                _archive.on('click', ".filter-submit button[name=reset]", function () {

                    _filter_container.find('input[type=checkbox]').prop("checked", false);
                    opt.filter = null;
                    opt.page = 1;

                    if (_archive.find('.js--filter-inner').hasClass('is-active')) {
                        _archive.find('.js--filter-inner').removeClass('is-active');
                    }

                    call_posts(opt, true);

                });

                // Filter Check-all check
                _archive.find('.js--filter-select-all').click(function () {
                    let all_elements = $(this).closest('.filter-select').find('input');
                    if ($(this).is(":checked")) {
                        all_elements.prop("checked", true);
                    } else {
                        all_elements.prop("checked", false);
                    }
                });

                // Sub Categories Filters
                _archive.find('.filter-select button').click(function () {
                    let parent = $(this).parent().parent();
                    if (parent.hasClass('is-open')) {
                        $(this).html('+');
                        parent.removeClass('is-open');
                    } else {
                        $(this).html('-');
                        parent.siblings().find('button').html('+');
                        parent.addClass('is-open').siblings().removeClass('is-open');
                    }


                });


                // Open Filter
                _archive.find('.js--filter-trigger').on('click', function () {
                    _archive.find('.js--filter-inner').addClass('is-active');
                });

                // Close Filter on Outside
                $(document).on('click', function (e) {

                    if ($(e.target).is('.js--filter-box,.js--filter-box *, .js--filter-inner, .js--filter-inner *') === false) {

                        if (_archive.find('.js--filter-inner').hasClass('is-active')) {
                            _archive.find('.js--filter-inner').removeClass('is-active');
                        }

                    }
                });

                // Close Filter on Click [Esc]
                $(document).on('keydown', function (event) {
                    if (event.key === "Escape") {
                        if (_archive.find('.js--filter-inner').hasClass('is-active')) {
                            _archive.find('.js--filter-inner').removeClass('is-active');
                        }
                    }
                });

                // Close Filter on Button Close Click
                $('.filter-close').on('click', function (e) {
                        if (_archive.find('.js--filter-inner').hasClass('is-active')) {
                            _archive.find('.js--filter-inner').removeClass('is-active');
                        }
                    }
                );


            });
        },

        events_form: function () {
            let emails = $('body').find('article[data-emails]').data('emails');
            if (emails) {
                $('.event--signup-form').find('.js--wpform-emails input').val(emails);
                $('.event--signup-form').find('.js--wpform-emails textarea').text(emails);
            }

            let dates = $('body').find('article[data-emails]').data('dates');
            if (dates) {
                let select = $('.event--signup-form').find('.js--wpform-dates select');
                select.empty();
                $(dates).each(function (i, v) {
                    select.append($('<option>', {value: v, text: v}));
                });
            }

        },

        team_filter: function () {

            $('.js--team-section').on('click', 'button', function () {
                $(this).closest('.js--team-section').find('.filter--list').slideToggle(200);
            });

            $('.js--team-section').on('click', '.filter--list li', function () {

                let value = $(this).text();

                if ($(this).is(':first-child')) {
                    $(".js--team .team-section").removeClass('is-empty');
                    $('.js--team-section button').click();
                    $('.js--team-section button span').text(value);
                    return;
                }


                $('.js--team-section button span').text(value);
                $('.js--team-section button').click();

                $(".js--team .team-section").filter(function () {

                    if ($(this).find('h3').text().toLowerCase().indexOf(value.toLowerCase()) > -1) {
                        $(this).removeClass('is-empty');
                    } else {
                        $(this).addClass('is-empty');
                    }

                });


            });

            $(".js--team-search input").on("input", function () {

                let value = $(this).val().toLowerCase();


                if (value.length < 3) {
                    $('.js--team').removeClass('search-on');
                } else {
                    $('.js--team').addClass('search-on');
                }

                $(".js--team .team-section .contact-item--grid .contact-item").filter(function () {
                    if ($(this).text().toLowerCase().indexOf(value) > -1) {
                        $(this).addClass('is-selected');
                    } else {
                        $(this).removeClass('is-selected');
                    }
                });


                SectionReset();
            });


            let SectionReset = function () {
                $('.js--team .team-section .contact-item--grid').each(function (index, x) {

                    var found = $(this).find('.contact-item.is-selected').length;

                    if (found <= 0) {
                        $(this).parent().addClass('is-empty');
                    } else {
                        $(this).parent().removeClass('is-empty');
                    }

                });
            };

        },

        yt_block: function () {
            let yt = $('.v-container.v-type-yt');

            if (!yt.length)
                return;

            yt.each(function (index, item) {

                let video_container =  $(item).find('.yt-video');
                let video_overlay = $(item).find('.yt-overlay');
                let video = video_container.data('video');
                let video_cookie = Cookies.get('yt_load');


                $(item).find('.yt-load').click(function () {

                    let video_check = $(item).find('input[name*=yt-always-load]').is(':checked');

                    if(video_check){
                        Cookies.set('yt_load', '1',{ expires: 2 });
                    }
                    video_overlay.fadeOut('fast');
                    video_container.html('<iframe loading="lazy" src="https://www.youtube-nocookie.com/embed/' + video +
                        '?vq=hd1080&modestbranding=1&rel=0&hl=de-de&fs=0&color=white&controls=0&disablekb=1"' +
                        'width="1280" height="720" frameBorder="0"></iframe>');

                });

                if(video_cookie==='1'){
                    video_overlay.fadeOut('fast');
                    video_container.html('<iframe loading="lazy" src="https://www.youtube-nocookie.com/embed/' + video +
                        '?vq=hd1080&modestbranding=1&rel=0&hl=de-de&fs=0&color=white&controls=0&disablekb=1"' +
                        'width="1280" height="720" frameBorder="0"></iframe>');
                }


            });

        }
    };


    let Elementor_N49 = {


        block__logo_slider: function () {

            $('.js--logo-slider').not('.slick-initialized').slick({
                // autoplay: true,
                // autoplaySpeed: 2000,
                autoplay: true,
                autoplaySpeed: 1500,
                slidesToShow: 4,
                adaptiveHeight: false,
                arrows: false,
                dots: false,
                infinite: true,
                responsive: [
                    //tablet
                    {
                        breakpoint: 767,
                        settings:
                            {
                                slidesToShow: 3
                            },

                    },
                    //mobile
                    {
                        breakpoint: 480,
                        settings:
                            {
                                slidesToShow: 2
                            },

                    }

                ]
            });


        },

        block__archive_slider: function () {
            $('.js--archive-slider').not('.slick-initialized').slick({
                // autoplay: true,
                // autoplaySpeed: 2000,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 3,
                adaptiveHeight: false,
                arrows: false,
                dots: false,
                infinite: true,

                responsive: [
                    //mobile
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        }
                    }

                ]
            });
        },

        block__feature_slider: function () {
            let feature_slider = $('.js--feature-slider').not('.slick-initialized').slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                adaptiveHeight: false,
                arrows: false,
                dots: false,
                fade: true,
                speed: 300,
                infinite: false,


            });

            $('.feature-slider-nav .feature').eq(0).addClass('is-active');

            $('.feature-slider-nav').on('click', '.feature', function () {
                feature_slider.slick('slickGoTo', $(this).index());
                $(this).addClass('is-active').siblings().removeClass('is-active');
            });

            feature_slider.on('afterChange', function (event, slick, currentSlide) {
                var dataId = $(slick.$slides[currentSlide]).data('slick-index');
                $('.feature-slider-nav').find('.feature').eq(dataId).addClass('is-active').siblings().removeClass('is-active');

                let color = $('.feature-slider-nav .feature.is-active').data('color');
                $('.featured-links').attr('class', 'featured-links').addClass('set-color--' + color);
            });

        },

        block__gallery_slider: function () {

            $('.js--gallery-slider').not('.slick-initialized').slick({
                // autoplay: true,
                // autoplaySpeed: 2000,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                adaptiveHeight: false,
                arrows: true,
                dots: true,
                infinite: true,
            });


        },

        block__archive: function (part = 'news') {
            $('.js--archive-ajax .list-pagination ul').not('.slick-initialized').slick({
                autoplay: false,
                slidesToShow: 5,
                slidesToScroll: 5,
                adaptiveHeight: false,
                arrows: true,
                dots: false,
                infinite: false,
                swipe: false,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            swipe: true,
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    }
                ],
            });
        }
    }

    N49.init();


    $(window).on('elementor/frontend/init', function () {
        //hook name is 'frontend/element_ready/{widget-name}.{skin} - i dont know how skins work yet, so for now presume it will
        //always be 'default', so for example 'frontend/element_ready/slick-slider.default'
        //$scope is a jquery wrapped parent element
        elementorFrontend.hooks.addAction('frontend/element_ready/n49__logo_slider.default', function ($scope, $) {
            Elementor_N49.block__logo_slider();
        });
        elementorFrontend.hooks.addAction('frontend/element_ready/n49__archive_slider_images.default', function ($scope, $) {
            Elementor_N49.block__archive_slider();
        });

        elementorFrontend.hooks.addAction('frontend/element_ready/n49__archive_slider.default', function ($scope, $) {
            Elementor_N49.block__archive_slider();
        });

        elementorFrontend.hooks.addAction('frontend/element_ready/n49__gallery.default', function ($scope, $) {
            Elementor_N49.block__gallery_slider();
        });

        elementorFrontend.hooks.addAction('frontend/element_ready/n49__feature_slider.default', function ($scope, $) {
            Elementor_N49.block__feature_slider();
        });


        elementorFrontend.hooks.addAction('frontend/element_ready/n49__archive_news.default', function ($scope, $) {
            Elementor_N49.block__archive('news');
        });

        elementorFrontend.hooks.addAction('frontend/element_ready/n49__archive_kompetenzsuche.default', function ($scope, $) {
            Elementor_N49.block__archive('kompetenzsuche');
        });

        elementorFrontend.hooks.addAction('frontend/element_ready/n49__archive_termine.default', function ($scope, $) {
            Elementor_N49.block__archive('termine');
        });

        elementorFrontend.hooks.addAction('frontend/element_ready/n49__archive_stellenanzeigen.default', function ($scope, $) {
            Elementor_N49.block__archive('stellenanzeigen');
        });


    });


}(jQuery));